import { rawMap } from './cobrandedPages'
import geoPages from './geoPages'
import statePages from './statePages'

const geoPagesMeta = geoPages.reduce((acc, { url, title }) => {
  acc[`/${url}/`] = { title: `Join in ${title}` }
  return acc
}, {})

const statePagesMeta = statePages.reduce((acc, { url, stateName }) => {
  acc[`/${url}/`] = {
    title: `Join in ${stateName.replace(/^./, match => match.toUpperCase())}`,
  }
  return acc
}, {})

const cobrandedPagesMeta = Object.entries(rawMap).reduce(
  (acc, [key, { metaTitle, metaImage, metaDescription }]) => {
    acc[key] = {
      title: metaTitle,
      description: metaDescription,
      image: metaImage,
    }
    return acc
  },
  {}
)

export default {
  '/blog/': {
    title: 'Blog',
  },
  '/coverage/': {
    title: 'Coverage',
  },
  '/glossary/': {
    title: 'Insurance Glossary',
    description:
      'Decipher the insurance world, one term at a time. Language here represents an attempt to make insurance more accessible.',
  },
  '/about/': {
    title: 'About',
  },
  '/careers/': {
    title: 'Careers',
  },
  '/press/': {
    title: 'Press & Media',
  },
  '/insurance-guide/': {
    title: 'Ultimate guide to renters insurance',
  },
  '/reviews/': {
    title: 'Reviews',
  },
  '/privacy-policy/': {
    title: 'Privacy Policy',
  },
  '/legal-notices/': {
    title: 'Legal Notices',
  },
  '/terms-and-conditions/': {
    title: 'Terms and conditions',
  },
  '/join/': {
    title: 'Join',
  },
  '/blog/free-insurance-for-medical-responders-covid19/': {
    image: {
      url: 'https://www.goodcover.com/images/openGraph/waves-red-circle-supergraphic-thick-medic-1500-opti.png',
      width: '1500',
      height: '971',
      alt: 'Medical Icon',
    },
  },
  '/blog/is-insurance-more-expensive-in-black-neighborhoods/': {
    image: {
      url: 'https://www.goodcover.com/images/openGraph/black-percent-vs-price-bar-chart.png',
      width: '1200',
      height: '900',
      alt: 'Black neighborhoods pay 20% more in renters insurance',
    },
  },
  ...geoPagesMeta,
  ...statePagesMeta,
  ...cobrandedPagesMeta,
}
